<template>
  <div class="stat-loader" v-if="display"></div>

  <!--todo - display spinner-->
</template>

<script>
  export default {
    name: "StatLoader",
    props: {
      display: {
        required: true,
        format: Boolean
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Dashboard/Statistics/Partials/Loader.vue